/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelManageAddGroupCharterQuotaPost } from '../fn/buy-charter-quota-endpoint/api-hotel-manage-add-group-charter-quota-post';
import { ApiHotelManageAddGroupCharterQuotaPost$Params } from '../fn/buy-charter-quota-endpoint/api-hotel-manage-add-group-charter-quota-post';
import { apiHotelManageAddSingleCharterQuotaPost } from '../fn/buy-charter-quota-endpoint/api-hotel-manage-add-single-charter-quota-post';
import { ApiHotelManageAddSingleCharterQuotaPost$Params } from '../fn/buy-charter-quota-endpoint/api-hotel-manage-add-single-charter-quota-post';
import { StatusedBasedResponseInfoIEnumerableResultApiResult } from '../models/statused-based-response-info-i-enumerable-result-api-result';

@Injectable({ providedIn: 'root' })
export class BuyCharterQuotaEndpointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHotelManageAddSingleCharterQuotaPost()` */
  static readonly ApiHotelManageAddSingleCharterQuotaPostPath = '/api/hotel/manage/add/single/charter-quota';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageAddSingleCharterQuotaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageAddSingleCharterQuotaPost$Response(params: ApiHotelManageAddSingleCharterQuotaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusedBasedResponseInfoIEnumerableResultApiResult>> {
    return apiHotelManageAddSingleCharterQuotaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageAddSingleCharterQuotaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageAddSingleCharterQuotaPost(params: ApiHotelManageAddSingleCharterQuotaPost$Params, context?: HttpContext): Observable<StatusedBasedResponseInfoIEnumerableResultApiResult> {
    return this.apiHotelManageAddSingleCharterQuotaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatusedBasedResponseInfoIEnumerableResultApiResult>): StatusedBasedResponseInfoIEnumerableResultApiResult => r.body)
    );
  }

  /** Path part for operation `apiHotelManageAddGroupCharterQuotaPost()` */
  static readonly ApiHotelManageAddGroupCharterQuotaPostPath = '/api/hotel/manage/add/group/charter-quota';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelManageAddGroupCharterQuotaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageAddGroupCharterQuotaPost$Response(params: ApiHotelManageAddGroupCharterQuotaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusedBasedResponseInfoIEnumerableResultApiResult>> {
    return apiHotelManageAddGroupCharterQuotaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelManageAddGroupCharterQuotaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelManageAddGroupCharterQuotaPost(params: ApiHotelManageAddGroupCharterQuotaPost$Params, context?: HttpContext): Observable<StatusedBasedResponseInfoIEnumerableResultApiResult> {
    return this.apiHotelManageAddGroupCharterQuotaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatusedBasedResponseInfoIEnumerableResultApiResult>): StatusedBasedResponseInfoIEnumerableResultApiResult => r.body)
    );
  }

}
